export default __webpack_public_path__ + "static/media/woodChair.b8b056b8.png";